module.exports = __webpack_public_path__ + "img/whole.5e1ea4e7.png";